export const HEADER_LINK_REDIRECT_LOGO = "header_link_redirect_logo"
export const HEADER_LINK_REDIRECT_OLD_VERSION =
  "header_link_redirect_old_version"
export const HEADER_SELECT_UPDATE_CUSTOMER_SELECTOR =
  "header_select_update_customer_selector"
export const HEADER_BUTTON_LOGOUT = "header_button_logout"
export const MENU_SECTION_NAVIGATION = "menu_sectin_navigation"
export const MENU_LINK_NAVIGATION_HOME = "menu_link_navigation_home"
export const MENU_BUTTON_OPEN_LINKS_FATURAS = "menu_button_open_links_faturas"
export const MENU_LINK_NAVIGATION_MINHAS_FATURAS =
  "menu_link_navigation_minhas_faturas"
export const MENU_LINK_NAVIGATION_DETALHAMENTO =
  "menu_link_navigation_detalhamento"
export const MENU_LINK_NAVIGATION_DEBITO_AUTOMATICO =
  "menu_link_navigation_debito_automatico"
export const MENU_LINK_NAVIGATION_NEGOCIAR_FATURAS =
  "menu_link_navigation_negociar_faturas"
export const MENU_LINK_NAVIGATION_PRODUTOS = "menu_link_navigation_produtos"
export const MENU_LINK_NAVIGATION_SUPPORT_TECNICO =
  "menu_link_navigation_SUPPORT_TECNICO"
export const MENU_LINK_NAVIGATION_PROTOCOLOS = "menu_link_navigation_protocolos"
export const MENU_LINK_NAVIGATION_COTA_DADOS = "menu_link_navigation_cota_dados"
export const MENU_LINK_NAVIGATION_PERFIL_DE_CONSUMO =
  "menu_link_navigation_perfil_de_consumo"
export const MENU_LINK_NAVIGATION_VOZ_FIXA = "menu_link_navigation_voz_fixa"
export const MENU_LINK_NAVIGATION_CADASTRO = "menu_link_navigation_cadastro"
export const MENU_LINK_NAVIGATION_PEDIDOS_CONTRATOS =
  "menu_link_navigation_pedidos_contratos"
export const MENU_LINK_NAVIGATION_INTERFACE_ONLINE =
  "menu_link_navigation_interface_online"
export const MENU_LINK_NAVIGATION_MANUAL_USER =
  "menu_link_navigation_manual_user"
export const MENU_LINK_NAVIGATION_SHARED_DATA =
  "menu_link_navigation_shared_data"
export const MENU_LINK_NAVIGATION_RECHARGE_DOCUMENTS =
  "menu_link_navigation_documentos_recarga"
export const MENU_LINK_NAVIGATION_GESTAO_BANDA_LARGA =
  "menu_link_navigation_gestao_banda_larga"
export const MENU_BUTTON_LOGOUT = "menu_button_logout"
export const MENU_BUTTON_SEND_EMAIL = "menu_button_send_email"
export const MENU_BUTTON_SEND_WHATSAPP = "menu_button_send_whatsapp"
export const INVOICE_BUTTON_DOWNLOAD_SELECTED =
  "invoice_button_download_selected"
export const INVOICE_BUTTON_DUPLICATE = "invoice_button_duplicate"
export const INVOICE_BUTTON_PAY_WITH_PIX = "invoice_button_pay_with_pix"
export const INVOICE_BUTTON_BAR_CODE = "invoice_button_bar_code"
export const INVOICE_BUTTON_BILLET = "invoice_button_bank_slip"
export const INVOICE_BUTTON_EXCEL_DETAIL = "invoice_button_excel_detail"
export const INVOICE_BUTTON_PDF_DETAIL = "invoice_button_pdf_detail"
export const INVOICE_BUTTON_SEND_BY_EMAIL = "invoice_button_send_by_email"
export const INVOICE_BUTTON_CONTESTATION_VALUES =
  "invoice_button_contestation_values"
export const INVOICE_LINK_SEE_ALL_INVOICES =
  "invoice_button_contestation_values"
export const INVOICE_CONTAINER_LIST_PAID_INVOICES =
  "invoice_container_list_paid_invoices"
export const INVOICE_CLOSE_MODAL_BUTTON = "invoice_close_modal_button"
export const INVOICE_BACK_MODAL_BUTTON = "invoice_back_modal_button"
export const INVOICE_CANCEL_MODAL_BUTTON = "invoice_cancel_modal_button"
export const INVOICE_CONFIRM_MODAL_BUTTON = "invoice_confirm_modal_button"
export const PAID_INVOICES_ITEM_LIST_MONTH = "paid_invoics_item_list_month"
export const PAID_INVOICES_BUTTON_MONTH = "paid_invoices_button_moth"
export const HEADER_BUTTON_NOTIFICATION = "header_button_notification"
export const ATT_USER_YES = "att_user_yes"
export const ATT_USER_NO = "att_user_no"
export const BLOCKED_PRODUCT_YES = "blocked_product_yes"
export const BLOCKED_PRODUCT_NO = "blocked_product_no"
export const BANNER_BUTTON_REDIRECT_SOLUCOES_TI =
  "banner_button_redirect_solucoes_ti"
export const BANNER_LINK_NAVIGATION_ALGAR_SEMPRE =
  "banner_link_navigation_algar_sempre"
export const BANNER_LINK_REDIRECT_MANUAL_USER =
  "banner_link_redirect_manual_user"
export const HOME_LINK_NAVIGATION_NEGOCIAR_FATURAS =
  "home_link_navigation_negociar_faturas"
export const HOME_LINK_NAVIGATION_SUPORTE_TECNICO =
  "home_link_navigation_suporte_tecnico"
export const HOME_LINK_NAVIGATION_MEUS_PROTOCOLOS =
  "home_link_navigation_meus_protocolos"
export const MENU_LINK_NAVIGATION_USERS = "menu_link_navigation_users"
export const INVOICE_BUTTON_MODAL_AUTOMATIC_DEBIT =
  "invoice_button_modal_automatic_debit"
export const INVOICE_BUTTON_MODAL_EXPIRY_DATE =
  "invoice_button_modal_expire_date"
export const INVOICE_BUTTON_MODAL_FEBRABAN_ACCOUNT =
  "invoice_button_modal_febraban_account"
export const INVOICE_BUTTON_MODAL_RECEIVING_TYPE =
  "invoice_button_modal_receiving_type"
export const AUTOMATIC_DEBIT_BILLS_SELECT = "automatic_debit_bills_select"
export const PRODUCTS_SELECT_FILTER_PRODUCTS = "products_select_filter_products"
export const PRODUCTS_INPUT_FILTER_PRODUCTS = "products_input_filter_products"
export const PRODUCTS_BUTTON_FILTER_PRODUCTS = "products_button_filter_products"
export const PRODUCTS_BUTTON_DOWNLOAD_EXCEL = "products_button_download_excel"
export const PRODUCTS_BUTTON_DOWNLOAD_PDF = "products_button_download_pdf"
export const PRODUCTS_COLUMN_ORDER_PRODUCT = "products_column_order_product"
export const PRODUCTS_COLUMN_ORDER_STATUS = "products_column_order_status"
export const PRODUCTS_COLUMN_ORDER_CIRCUIT = "products_column_order_circuit"
export const PRODUCTS_COLUMN_ORDER_LINE_OF_BUSINESS =
  "products_column_order_line_of_business"
export const PRODUCTS_COLUMN_ORDER_ACTIVE = "products_column_order_active"
export const PRODUCTS_COLUMN_PRODUCT = "products_column_product"
export const PRODUCTS_COLUMN_STATUS = "products_column_status"
export const PRODUCTS_COLUMN_CIRCUIT = "products_column_circuit"
export const PRODUCTS_COLUMN_LINE_OF_BUSINESS =
  "products_column_line_of_business"
export const PRODUCTS_COLUMN_ADDRESS = "products_column_address"
export const PRODUCTS_COLUMN_ACTIVE = "products_column_active"
export const PRODUCTS_BUTTON_FIRST_PAGE = "products_button_first_page"
export const PRODUCTS_BUTTON_PREV_ARROW = "products_button_prev_arrow"
export const PRODUCTS_BUTTON_PREV_PAGE = "products_button_prev_page"
export const PRODUCTS_BUTTON_NEXT_PAGE = "products_button_next_page"
export const PRODUCTS_BUTTON_NEXT_ARROW = "products_button_next_arrow"
export const PRODUCTS_SELECT_NUMBER_PAGE = "products_select_number_page"
export const PRODUCTS_BUTTON_OPEN_MENU_PRODUCT =
  "products_button_open_menu_product"
export const PRODUCTS_BUTTON_CANCEL_PRODUCT = "products_button_cancel_product"
export const PRODUCTS_BUTTON_UNLOCK_TRUST = "products_button_unlock_trust"
export const PRODUCTS_BUTTON_ADDRESS_CHANGE = "products_button_address_change"
export const MODAL_BUTTON_CLOSE_MODAL_HEADER = "modal_button_close_modal_header"
export const MODAL_BUTTON_CLOSE_MODAL_UNTITLED_HEADER =
  "modal_button_close_modal_untitled_header"
export const MODAL_BUTTON_UNLOCK_MODAL_REQUEST =
  "modal_button_unlock_modal_request"
export const MODAL_BUTTON_SEE_RULES_UNLOCK_MODAL_RESPONSE =
  "modal_button_see_rules_unlock_modal_response"
export const MODAL_BUTTON_FINISH_MODAL_RULES_UNBLOCK =
  "modal_button_finish_modal_rules_unblock"
export const MODAL_BUTTON_FINISH_MODAL_RESPONSE =
  "modal_button_finish_modal_response"
export const PRODUCTS_BUTTON_GO_TO_HOME = "products_button_go_to_home"
export const PRODUCTS_BUTTON_RELOAD = "products_button_reload"
export const INVOICE_CHECKBOX_SELECT_ACCOUNT = "invoice_checkbox_select_account"
export const INVOICE_BUTTON_OPEN_OPTIONS_ACCOUNT =
  "inovice_button_open_options_account"
export const INVOICES_BUTTON_PAYMENT_BAR_CODE =
  "invoices_button_payment_bar_code"
export const HOME_LINK_NAVIGATION_INTERFACE_ONLINE =
  "home_link_navigation_interface_online"

export const ORDERS_COLUMN_HEADER_ORDER = "orders_column_header_order"
export const ORDERS_COLUMN_HEADER_PRODUCTS = "orders_column_header_products"
export const ORDERS_COLUMN_ORDER = "orders_column_order"
export const ORDERS_COLUMN_PRODUCTS = "orders_column_products"

export const INTERFACE_ONLINE_BUTTON_NEW_SCHEDULE =
  "interface_online_button_new_schedule"
export const INTERFACE_ONLINE_BUTTON_RESCHEDULE =
  "interface_online_button_reschedule"
export const INTERFACE_ONLINE_BUTTON_INTERRUPT_SCHEDULE =
  "interface_online_button_interrupt_schedule"
export const INTERFACE_ONLINE_BUTTON_CANCEL_SCHEDULE =
  "interface_online_button_cancel_schedule"
export const RECHARGE_DOCUMENTS_BUTTON_SEARCH =
  "recharge_documents_button_search"
export const RECHARGE_DOCUMENTS_BUTTON_DOWNLOAD =
  "recharge_documents_button_download"
export const RECHARGE_DOCUMENTS_BUTTON_DOWNLOAD_SELECTED =
  "recharge_documents_download_selected"
export const RECHARGE_DOCUMENTS_BUTTON_NF = "recharge_documents_download_nf"
export const RECHARGE_DOCUMENTS_BUTTON_INVOICES =
  "recharge_documents_download_invoices"
export const MENU_LINK_NAVIGATION_MONITORAMENTO =
  "menu_link_navigation_monitoramento"



// WEBPACK FOOTER //
// ./src/shared/constants/idsElements.js